import React, { memo } from 'react'
import Help from 'transfix-icons/build/HelpIcon'
import WarningFilledIcon from 'transfix-icons/build/WarningFilledIcon'
import { TProgressLevel } from 'transfix-ui/components/ProgressIcon/ProgressIcon'
import { IconWrapper, ProgressIcon } from 'transfix-ui'

// Sets color and size for Icon children components
const HelpIcon = () => (
  <IconWrapper Icon={Help} color='coolGray5' BoxProps={{ display: 'flex', alignItems: 'center' }} />
)

const WarningIcon = () => (
  <IconWrapper
    Icon={WarningFilledIcon}
    color='warning'
    BoxProps={{ display: 'flex', alignItems: 'center' }}
  />
)

export type TOtherIcon = 'warning' | 'help'
export type TIconName = TProgressLevel | TOtherIcon

/**
 * Helper method to get the right <Icon /> element
 */
const getIcon = (iconName: TIconName): JSX.Element => {
  switch (iconName) {
    case 'help':
      return <HelpIcon />
    case 'warning':
      return <WarningIcon />
    case '0':
    case '25':
    case '50':
    case '75':
    case '100':
      return <ProgressIcon progress={iconName} />
    default:
      return <ProgressIcon progress='0' />
  }
}

interface IActionListIconProps {
  /**
   * @example 'warning'
   * @default '0'
   */
  iconName?: TIconName
}

export const ActionListIcon = memo<IActionListIconProps>(({ iconName = '0' }) => {
  return getIcon(iconName)
})
